import { render, staticRenderFns } from "./CinematicRentalCard.vue?vue&type=template&id=7006cfce&scoped=true"
import script from "./CinematicRentalCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CinematicRentalCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CinematicRentalCard.vue?vue&type=style&index=0&id=7006cfce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7006cfce",
  null
  
)

export default component.exports